import React, { Component } from "react";
import { withRouter, NavLink } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import {
  showContract,
  deletePayment,
  updateContract,
  resendEmail
} from "../../../actions/contracts";
import {fetchBreederInfo,updateBreeder,deleteBreederVaccine} from "../../../actions/breeders"
import { NotificationManager } from "react-notifications";
import { Loader } from "../../../components/loader";
import { fetchHwFindUs } from "../../../actions/howFindUs";
import PhoneInput from "react-phone-number-input";
import { BreadCrumb } from "../../../components/breadcrumb";
import PerfectScrollbar from "react-perfect-scrollbar";
import AddMedicationScheduleForm from "./addMedicationSchedule";
import "react-phone-number-input/style.css";



const $ = window.$;
let edit_form = {};

const scroll = {};

class ContractsView extends Component {
  constructor(props) {
    super(props);
    this.contractPdf = React.createRef();
  }
  state = {   

    editBreeder: false,
    loadingBreeder: false,
    deleteContractId: null,
    loading: false,
    breeder: "",
    usda_no:"", 
    addressLine1:"",
    usda_no:"",
    addressLine1:"",
    addressLine2:"",
    addressCity:"",
    addressState:"",
    addressCountry:"",
    mediModalType:"",
    phone:"",
    addressPostalCode:"",
    deleteBreederVaccineId:null,
    breederInfo: {
      BreederVaccines:[]
    }
  };

  componentDidMount() {    
    this.props.fetchBreederInfo(this.props.match.params.id);
    this.setState({ country: this.props.petShop.currentPetshop.country, loading : true });
    
  }

  componentWillReceiveProps = nextProps => {
   
    if (
      this.props.data.breederReducer.breederInfo !==
      nextProps.data.breederReducer.breederInfo
    ) {     
      this.setState({
      breederInfo: nextProps.data.breederReducer.breederInfo, loading : false});  
    }

    if (
      this.props.data.breederReducer.updatedBreeder !==
      nextProps.data.breederReducer.updatedBreeder
    ) {
      let breederObj = nextProps.data.breederReducer.updatedBreeder;
      if(breederObj){     
      this.setState({ editBreeder: false });   
      $("#confirm_samebreederupdate_modal").modal("hide");
      this.props.fetchBreederInfo(this.props.match.params.id);
      NotificationManager.success("Breeder info updated succesfully.");
    }
    else{
      NotificationManager.warning("Something wrong in update.");
    }

    }

    if (
      this.props.data.breederReducer.deletedBreederVaccine !==
      nextProps.data.breederReducer.deletedBreederVaccine
    ) {
    this.props.fetchBreederInfo(this.props.match.params.id);  
    $("#confirm_delete_modal").modal("hide");
    NotificationManager.success("Breeder vaccine deleted succesfully.");
    }

    if (
      this.props.data.breederReducer.createdBreederVaccines !==
      nextProps.data.breederReducer.createdBreederVaccines
    ) {
      this.props.fetchBreederInfo(this.props.match.params.id);   
 
    }

    if (
      this.props.data.breederReducer.updatedBreederError !==
      nextProps.data.breederReducer.updatedBreederError
    ) {     
      if (nextProps.data.breederReducer.updatedBreederError.message && (nextProps.data.breederReducer.updatedBreederError.message === 'Breeder name already exists')) {
       
        $("#confirm_samebreederupdate_modal").modal("show"); 

      } else {
        NotificationManager.error(
          "Something went wrong when saving New Breeder"
        );
       // this.resetState();
      }
    }  
  
  }
  editBreeder = () => {  
    if (!this.state.editBreeder) {
      this.setState({
        editBreeder: true,
        breeder: this.state.breederInfo.breeder || "",
        usda_no: this.state.breederInfo.usda_no || "",
        addressLine1: this.state.breederInfo.addressLine1 || "",
        addressLine2: this.state.breederInfo.addressLine2 || "",    
        addressCity: this.state.breederInfo.addressCity || "",
        addressState: this.state.breederInfo.addressState || "",
        addressCountry: this.state.breederInfo.addressCountry || "",
        mediModalType: this.state.breederInfo.mediModalType || "",
        phone: this.state.breederInfo.phone || "",
        addressPostalCode: this.state.breederInfo.addressPostalCode || "",       
        
      });
    } else {
      this.setState({ editBreeder: false });
    }
  };

  changeVal = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
 

  openConfirmModal = (cpId) => {   
     this.setState({ deleteBreederVaccineId: cpId });
    $("#confirm_delete_modal").modal("show");
  };
  getPaymentMethod = typeId => {
    return this.state.paymentTypes.find(({ id }) => id === typeId);
  };
  
  deleteBreederVaccine(vc){
     let data = this.state.deleteBreederVaccineId ;     
    if (data) this.props.deleteBreederVaccine(data);
    else {
      NotificationManager.warning("Medications data can not be found.");
      this.setState({ loadingDelete: false });
    }
  }
  validateForm = edit_form => {
    let id =  this.props.match.params.id;
    let data = Object.entries(edit_form).map(([key, value]) => {
      if (value === "invalid") {
        return "invalid";      
      } else {
        return value;
      }
    });
    if (!data.includes("invalid")) {
      this.props.updateBreeder(id,edit_form);
    } else {
      NotificationManager.warning("Please check input details again."); 
    }
  };
  saveBreeder = () => {   
    edit_form = {
      breeder: this.state.breeder && this.state.breeder.trim().length > 0 ? this.state.breeder: 'invalid',
      usda_no: this.state.usda_no && this.state.usda_no.trim().length > 0 ? this.state.usda_no : 'invalid',
      addressLine1: this.state.addressLine1 && this.state.addressLine1.trim().length > 0 ? this.state.addressLine1 : 'invalid',
      addressLine2: this.state.addressLine2 && this.state.addressLine2.trim().length > 0 ? this.state.addressLine2 : null,
      addressCity: this.state.addressCity && this.state.addressCity.trim().length > 0 ? this.state.addressCity : 'invalid',
      addressState: this.state.addressState && this.state.addressState.trim().length > 0 ? this.state.addressState : 'invalid',
      addressCountry: this.state.addressCountry && this.state.addressCountry.trim().length > 0 ? this.state.addressCountry : 'invalid',
      addressPostalCode: this.state.addressPostalCode && this.state.addressPostalCode.trim().length > 0 ? this.state.addressPostalCode : 'invalid',
      phone: this.state.phone && this.state.phone.trim().length > 0  ? this.state.phone : 'invalid',
      confirmExisting: false     
    };
    this.setState({ loadingBreeder: true });   
    this.validateForm(edit_form);
  };

  saveBreederNew = () => {   
     let id =  this.props.match.params.id;
    edit_form = {
      breeder: this.state.breeder.trim().length > 0 ? this.state.breeder: null,
      usda_no: this.state.usda_no.trim().length > 0 ? this.state.usda_no : null,
      addressLine1: this.state.addressLine1.trim().length > 0 ? this.state.addressLine1 : null,
      addressLine2: this.state.addressLine2.trim().length > 0 ? this.state.addressLine2 : null,
      addressCity: this.state.addressCity.trim().length > 0 ? this.state.addressCity : null,
      addressState: this.state.addressState.trim().length > 0 ? this.state.addressState : null,
      addressCountry: this.state.addressCountry.trim().length > 0 ? this.state.addressCountry : null,
      addressPostalCode: this.state.addressPostalCode.trim().length > 0 ? this.state.addressPostalCode : null,
      phone: this.state.phone.trim().length > 0  ? this.state.phone : null,
      confirmExisting: true     
    };
    this.setState({ loadingBreeder: true });
    this.props.updateBreeder(id,edit_form);
    
  };
  newMedication = (e, type) => {
    e.preventDefault();
    this.setState({ mediModalType: type });
    $("#add_medication").modal("show");
  };

  items = [
    { title: "Breeders", to: "/breeders" },
    { title: "Breeder Edit", to: "/breeders/" + this.props.match.params.id }
  ];

  acceptMethods(childDownload) {
    // Parent stores the method that the child passed
    this.childDownload = childDownload;
  }

  cancelEditInfo = () => {
    this.setState({ editBreeder: false });
  };

  breederCloseModal(){
    $("#confirm_samebreederupdate_modal").modal("hide");
  }

  render() {
    const {
      country,
      contract,
      editBreeder,
      breeder,    
      breederInfo,
      usda_no,
      addressLine1,
      addressLine2,
      addressCity,
      addressState,
      phone,
      addressCountry,
      addressPostalCode,
      mediModalType,
      loading,
          
    } = this.state;

    return (
      <div
        className="m-grid m-grid--hor m-grid--root m-page"
        style={{ minHeight: "100vh" }}
      >
      { !loading ?
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="row">
                <div className="col-lg-12">
                  <BreadCrumb items={this.items} />
                </div>              
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-8 col-md-8 col-lg-7">
                  <div className="m-portlet m-portlet--full-height ">                   
                    <div
                      className="m-portlet m-portlet--success m-portlet--head-solid-bg"
                      style={{ boxShadow: "none" }}
                    >              
                      <div className="m-portlet__head">
                        <div className="m-portlet__head-caption">
                          <div className="m-portlet__head-title">
                            <h3 className="m-portlet__head-text">
                              Breeder Information
                            </h3>
                          </div>
                        </div>
                        <div className="m-portlet__head-tools">
                          <button
                            onClick={() => this.editBreeder()}
                            className="m-portlet__nav-link btn btn-light m-btn m-btn--pill m-btn--air"
                          >
                            <i className="la la-edit"></i>
                            <span>Edit</span>
                          </button>                   
                        </div>
                      </div>
                      <div className="m-portlet__body">
                        <div className="m-widget4">
                          <div className="row mt-4">
                            <div className="col-md-12">
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-user mr-2"></i>
                                  <span>
                                    <strong>Breeder<span style={{ color: "red" }}> *</span>: </strong>
                                  </span>
                                  {editBreeder ? (
                                    <div className="m-form">
                                      <input
                                        type="text"
                                        name="breeder"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={breeder}
                                      />
                                      <span
                                        className={
                                          edit_form.breeder === 'invalid'                                       
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Enter breeder name
                                      </span>
                                    </div>
                                  ) : (
                                      breederInfo.breeder !== null &&
                                      breederInfo.breeder
                                    )}
                                </span>
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-map-pin mr-2"></i>
                                  <span>
                                    <strong>USDA Number<span style={{ color: "red" }}> *</span>: </strong>
                                  </span>
                                  {editBreeder ? (
                                    <div className="m-form">
                                      <input
                                        type="text"
                                        name="usda_no"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={usda_no}
                                      />
                                      <span
                                        className={
                                          edit_form.usda_no === 'invalid'                            
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Enter USDA number
                                      </span>
                                    </div>
                                  ) : (
                                    breederInfo.usda_no !== null &&
                                    breederInfo.usda_no
                                    )}
                                </span>
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-map-signs mr-2"></i>
                                  <span>
                                    <strong>Address Line 1<span style={{ color: "red" }}> *</span>: </strong>
                                  </span>
                                  {editBreeder ? (
                                    <div className="m-form">
                                      <input
                                        type="text"
                                        name="addressLine1"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={addressLine1}
                                      />
                                      <span
                                        className={
                                          edit_form.addressLine1 === 'invalid'                                    
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Enter address line 1
                                      </span>
                                    </div>
                                  ) : (
                                      breederInfo.addressLine1 !== null &&
                                      breederInfo.addressLine1
                                    )}
                                </span>
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-map-signs mr-2"></i>
                                  <span>
                                    <strong>Address Line 2: </strong>
                                  </span>
                                  {editBreeder ? (
                                    <div className="m-form">
                                      <input
                                        type="text"
                                        name="addressLine2"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={addressLine2}
                                      />
                                      <span
                                        className={
                                          edit_form.addressLine2 === null &&
                                            this.state.currentFormNotValid
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Enter address line 2
                                      </span>
                                    </div>
                                  ) : (
                                      breederInfo.addressLine2 !== null &&
                                      breederInfo.addressLine2
                                    )}
                                </span>
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-map-pin mr-2"></i>
                                  <span>
                                    <strong>City<span style={{ color: "red" }}> *</span>: </strong>
                                  </span>
                                  {editBreeder ? (
                                    <div className="m-form">
                                      <input
                                        type="text"
                                        name="addressCity"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={addressCity}
                                      />
                                      <span
                                        className={
                                          edit_form.addressCity === 'invalid'                                 
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Enter city
                                      </span>
                                    </div>
                                  ) : (
                                      breederInfo.addressCity !== null &&
                                      breederInfo.addressCity
                                    )}
                                </span>
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-map-pin mr-2"></i>
                                  <span>
                                    <strong>State<span style={{ color: "red" }}> *</span>: </strong>
                                  </span>
                                  {editBreeder ? (
                                    <div className="m-form">
                                      <input
                                        type="text"
                                        name="addressState"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={addressState}
                                      />
                                      <span
                                        className={
                                          edit_form.addressState === 'invalid'                                   
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Enter state
                                      </span>
                                    </div>
                                  ) : (
                                    breederInfo.addressState !== null &&
                                    breederInfo.addressState
                                    )}
                                </span>
                              </div>  
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-map-pin mr-2"></i>
                                  <span>
                                    <strong>Country<span style={{ color: "red" }}> *</span>: </strong>
                                  </span>
                                  {editBreeder ? (
                                    <div className="m-form">
                                      <input
                                        type="text"
                                        name="addressCountry"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={addressCountry}
                                      />
                                      <span
                                        className={
                                          edit_form.addressCountry === 'invalid'                                 
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Enter country
                                      </span>
                                    </div>
                                  ) : (
                                    breederInfo.addressCountry !== null &&
                                    breederInfo.addressCountry
                                    )}
                                </span>
                              </div> 
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-map-pin mr-2"></i>
                                  <span>
                                    <strong>Postal Code<span style={{ color: "red" }}> *</span>: </strong>
                                  </span>
                                  {editBreeder ? (
                                    <div className="m-form">
                                      <input
                                        type="text"
                                        name="addressPostalCode"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={addressPostalCode}
                                      />
                                      <span
                                        className={
                                          edit_form.addressPostalCode === 'invalid'                        
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Enter postal code
                                      </span>
                                    </div>
                                  ) : (
                                    breederInfo.addressPostalCode !== null &&
                                    breederInfo.addressPostalCode
                                    )}
                                </span>
                              </div> 
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-phone mr-2"></i>
                                   <span>
                                    <strong>
                                     Phone Number<span style={{ color: "red" }}> *</span>:                                  
                                    </strong>
                                  </span> 
                                  {editBreeder ? (
                                    <div className="m-form">
                                      <div className="input-group mb-1">                                    
                                        <PhoneInput
                                          country={country}
                                          className="form-control"
                                          placeholder="Enter phone number"
                                          value={phone}
                                          onChange={value =>{
                                            if(value){
                                            this.setState({
                                              phone: value
                                            })
                                          }
                                          else{
                                            this.setState({
                                              phone: ""
                                            })
                                          }
                                          }
                                          }
                                        />
                                      </div>
                                      <span
                                        className={
                                          edit_form.phone === 'invalid'                             
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Enter primary phone number
                                      </span>
                                    </div>
                                  ) : (
                                    breederInfo.phone !== null &&
                                    breederInfo.phone
                                    )}
                                </span>
                              </div>                                         
                            </div>
                           
                          </div>              
                          <div className="row">
                            <div className="col-md-12">                         
                              {editBreeder && this.state.loadingCustomer && (
                                <div className="center-row">
                                  <Loader size={50} />
                                </div>
                              )}
                            </div>
                            <div className="col-md-12">
                              {editBreeder && !this.state.loadingCustomer && (
                                <div className="m-widget4__action m--align-right">
                                  <button
                                    onClick={() => this.cancelEditInfo()}
                                    type="button"
                                    className="btn m-btn--pill btn-secondary mr-2"
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    onClick={() => this.saveBreeder()}
                                    type="button"
                                    className="btn m-btn--pill btn-outline-primary"
                                  >
                                    Save
                                  </button>
                                </div>
                              )}
                              {editBreeder && this.state.loadingCustomer && (
                                <div className="center-row">
                                  <Loader size={50} />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* </div> */}
                    </div>

                  </div>
                </div>
                <div className="col-xs-12 col-sm-8 col-md-8 col-lg-5">
                  <div className="m-portlet m-portlet--full-height">
                    <div
                      className="m-portlet m-portlet--success m-portlet--head-solid-bg"
                      style={{
                        boxShadow: "none",
                        height: "45%",
                        overflowY: scroll
                    
                      }}
                    >
                      <div className="m-portlet__head">
                        <div className="m-portlet__head-caption">
                          <div className="m-portlet__head-title">
                            <h3 className="m-portlet__head-text">
                              Vaccinations Schedule
                            </h3>
                          </div>
                        </div>
                        <div className="m-portlet__head-tools">
                          <button
                            onClick={(event) => this.newMedication(event, "vaccine")}
                            className="m-portlet__nav-link btn btn-light m-btn m-btn--pill m-btn--air"
                          >
                            <i className="la la-plus"></i>
                            <span>New Schedule</span>
                          </button>                   
                        </div>
                      </div>
                      <div className="m-portlet__body">
                        <PerfectScrollbar style={{ paddingRight: "25px" }}>
                          <div
                            className="m-accordion m-accordion--default"
                            id="m_accordion_4"
                            role="tablist"
                          >
                            {breederInfo.BreederVaccines.length > 0
                              ? breederInfo.BreederVaccines.filter(p => {
                                return p.Medication.type === "vaccine";
                              }).map((p, i) => (
                                <div
                                  className="m-accordion__item overlay-visible"
                                  key={i}
                                >
                                  <div
                                    className="m-accordion__item-head collapsed"
                                    role="tab"
                                    id={"m_accordion_4_item_" + i + "_head"}
                                    data-toggle="collapse"
                                    href={
                                      "#m_accordion_4_item_" + i + "_body"
                                    }
                                    aria-expanded="    false"
                                  >
                                    <span className="m-accordion__item-icon">
                                      <i className="fas fa-syringe"></i>
                                    </span>
                                    {p.Medication.type === "vaccine" ? (
                                      <span className="m-accordion__item-title">
                                        {" "}
                                          Vaccination {i + 1} -{" "}
                                        {p.Medication.name}{" "}
                                      </span>
                                    ) : p.Medication.type === "deworm" ? (
                                      <span className="m-accordion__item-title">
                                        {" "}
                                          Treatment {i + 1} -{" "}
                                        {p.Medication.name}
                                      </span>
                                    ) : null}
                                    <span className="m-accordion__item-mode"></span>
                                  </div>
                                  <div
                                    className="m-accordion__item-body collapse"
                                    id={"m_accordion_4_item_" + i + "_body"}
                                    role="tabpanel"
                                    aria-labelledby={
                                      "m_accordion_4_item_" + i + "_head"
                                    }
                                    data-parent="#m_accordion_4"
                                  >
                                    <div className="m-accordion__item-content">
                                      <div className="m-widget4">
                                        <div className="m-widget4__item">
                                          <span className="m-widget4__sub">
                                            <i className="fas fa-calendar-alt mr-2"></i>
                                            <span>
                                              <strong>Date Scheduled: </strong>
                                            </span>
                                            {p.Duration.label}
                                          </span>
                                        </div>
                                        <div className="m-widget4__item">
                                          <span className="m-widget4__sub">
                                            <i className="fas fa-clipboard-check mr-2"></i>
                                            <span>
                                              <strong>Vaccination Name: </strong>
                                            </span>
                                            {p.Medication.name}
                                          </span>
                                        </div>                                    
                                        <div className="m-widget4__item m--align-right">
                                          <span className="m-widget4__sub">
                                            <a
                                              href="#"
                                              onClick={() =>
                                                this.openConfirmModal(p.id)
                                              }
                                              className="btn m-btn--pill btn-outline-danger btn-sm mx-2"
                                            >
                                              <span>
                                                <i className="la la-minus-circle mr-2"></i>
                                                <span>Delete</span>
                                              </span>
                                            </a>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))
                              : null}
                          </div>                   
                        </PerfectScrollbar>
                      </div>
                    </div>
                    <div
                      className="m-portlet m-portlet--success m-portlet--head-solid-bg"
                      style={{
                        boxShadow: "none",
                        height: "45%",
                        overflowY: scroll
                    
                      }}
                    >
                      <div className="m-portlet__head">
                        <div className="m-portlet__head-caption">
                          <div className="m-portlet__head-title">
                            <h3 className="m-portlet__head-text">Treatments Schedule
                              <small>
                                Dewormings, Surgeries, Etc.
                              </small>
                            </h3>
                          </div>
                        </div>
                        <div className="m-portlet__head-tools">
                          <button
                            onClick={(event) => this.newMedication(event, "deworm")}
                            className="m-portlet__nav-link btn btn-light m-btn m-btn--pill m-btn--air"
                          >
                            <i className="la la-plus"></i>
                            <span>New Schedule</span>
                          </button>                   
                        </div>
                      </div>
                      <div className="m-portlet__body">
                        <PerfectScrollbar style={{ paddingRight: "25px" }}>
                          <div
                            className="m-accordion m-accordion--default"
                            id="m_accordion_5"
                            role="tablist"
                          >
                            {breederInfo.BreederVaccines.length > 0
                              ? breederInfo.BreederVaccines.filter(p => {
                                return p.Medication.type === "deworm";
                              }).map((p, i) => (
                                <div
                                  className="m-accordion__item overlay-visible"
                                  key={i}
                                >
                                  <div
                                    className="m-accordion__item-head collapsed"
                                    role="tab"
                                    id={"m_accordion_5_item_" + i + "_head"}
                                    data-toggle="collapse"
                                    href={
                                      "#m_accordion_5_item_" + i + "_body"
                                    }
                                    aria-expanded="    false"
                                  >
                                    <span className="m-accordion__item-icon">
                                      <i className="fas fa-syringe"></i>
                                    </span>
                                    {p.Medication.type === "vaccine" ? (
                                      <span className="m-accordion__item-title">
                                        {" "}
                                          Vaccination {i + 1} -{" "}
                                        {p.Medication.name}{" "}
                                      </span>
                                    ) : p.Medication.type === "deworm" ? (
                                      <span className="m-accordion__item-title">
                                        {" "}
                                          Treatment {i + 1} -{" "}
                                        {p.Medication.name}
                                      </span>
                                    ) : null}
                                    <span className="m-accordion__item-mode"></span>
                                  </div>
                                  <div
                                    className="m-accordion__item-body collapse"
                                    id={"m_accordion_5_item_" + i + "_body"}
                                    role="tabpanel"
                                    aria-labelledby={
                                      "m_accordion_5_item_" + i + "_head"
                                    }
                                    data-parent="#m_accordion_4"
                                  >
                                    <div className="m-accordion__item-content">
                                      <div className="m-widget4">
                                        <div className="m-widget4__item">
                                          <span className="m-widget4__sub">
                                            <i className="fas fa-calendar-alt mr-2"></i>
                                            <span>
                                              <strong>Date Scheduled: </strong>
                                            </span>
                                            {p.Duration.label}
                                          </span>
                                        </div>
                                        <div className="m-widget4__item">
                                          <span className="m-widget4__sub">
                                            <i className="fas fa-clipboard-check mr-2"></i>
                                            <span>
                                              <strong>Vaccination Name: </strong>
                                            </span>
                                            {p.Medication.name}
                                          </span>
                                        </div>                                    
                                        <div className="m-widget4__item m--align-right">
                                          <span className="m-widget4__sub">
                                            <a
                                              href="#"
                                              onClick={() =>
                                                this.openConfirmModal(p.id)
                                              }
                                              className="btn m-btn--pill btn-outline-danger btn-sm mx-2"
                                            >
                                              <span>
                                                <i className="la la-minus-circle mr-2"></i>
                                                <span>Delete</span>
                                              </span>
                                            </a>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))
                              : null}
                          </div>                    
                        </PerfectScrollbar>
                      </div>
                    </div>                
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>:
        <div className={"loader-center"}>
          <Loader
            type="line-scale"
            active={true}
            className="loader-center"
          />
        </div>
      }
        <div
          className="modal fade"
          id="confirm_delete_modal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="ConfirmationModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Confirm to delete
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this Schedule?</p>
              </div>
              <div className="modal-footer">               
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={() => this.deleteBreederVaccine()}
                      className="btn btn-primary m-btn--pill"
                    >
                      Confirm
                    </button>
                  </div>          
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="confirm_samebreederupdate_modal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="ConfirmationModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  WARNING
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>A breeder already exists with the same name and city. Are you sure you want to continue?</p>
              </div>
              <div className="modal-footer">
                <div>
                  <button
                    type="button"
                    onClick={() => this.breederCloseModal()}
                    className="btn btn-secondary m-btn--pill mx-2"
                    data-dismiss="modal"
                  >
                    Cancel
                    </button>
                  <button
                    type="button"
                    onClick={() => this.saveBreederNew()}
                    className="btn btn-primary m-btn--pill"
                  >
                    Create
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AddMedicationScheduleForm mrId={breederInfo.BreederVaccines.id} mediType={mediModalType} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  petShop: state.petShopReducer,
  user: state.cognito.user,
  data: state,
  hwTypes: state.howFindUsReducer.hwTypes,
  configs: state.configReducer.configs
});

const mapDispatchToProps = dispatch => ({
  showContract: id => {
    dispatch(showContract(id));
  },
  updateContract: (id, data) => {
    dispatch(updateContract(id, data));
  },
  deletePayment: id => {
    dispatch(deletePayment(id));
  },
  fetchHwFindUsTypes: () => {
    dispatch(fetchHwFindUs());
  }, 
  resendEmail: attrs => {
    dispatch(resendEmail(attrs));
  },
  fetchBreederInfo: id => {
    dispatch(fetchBreederInfo(id));
  },
  updateBreeder: (id, data) => {
    dispatch(updateBreeder(id, data));
  },
  deleteBreederVaccine:(id)=>{
    dispatch(deleteBreederVaccine(id));
  }
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ContractsView)
);
